<!-- 图片收集题：侧栏设置组件  -->
<template>
  <div class="image-card-setting">
    <vh-switch
      class="swtich"
      size="mini"
      v-model="isMust"
      active-color="#FB3A32"
      inactive-color="#CECECE"
      :inactive-text="$t('lang.k_379001')"
    ></vh-switch>
    <div class="tip-container">
      <p class="tip-row title">{{ $t('lang.k_379002') }}</p>
      <p class="tip-row">{{ $t('lang.k_379003') }}</p>
      <p class="tip-row">{{ $t('lang.k_379004') }}</p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: Boolean
    },
    computed: {
      isMust: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .image-card-setting {
    .tip-container {
      font-size: 14px;
      color: #8c8c8c;

      .tip-row {
        line-height: 1.6;
      }
      .tip-row.title {
        line-height: 2;
      }
    }
  }
</style>
